module.exports = __webpack_public_path__ + "img/text_check.b695478a.svg";